"use client";

import { useSearchParams } from "next/navigation";

const REASON_MESSAGES: Record<string, string> = {
  session_replaced:
    "You've been signed out because your account was signed in on another device. Each license allows one active session at a time.",
};

export default function LoginError() {
  const sp = useSearchParams();
  const error = sp.get("error");
  const reason = sp.get("reason");

  const reasonMessage = reason ? REASON_MESSAGES[reason] : null;

  return (
    <>
      {reasonMessage && (
        <div className="rounded-xl border border-amber-500/30 bg-amber-500/10 p-3 text-sm text-amber-200">
          {reasonMessage}
        </div>
      )}
      {error && !reasonMessage && (
        <div className="rounded-xl border border-red-500/30 bg-red-500/10 p-3 text-sm text-red-200">
          {decodeURIComponent(error)}
        </div>
      )}
    </>
  );
}
